<div class = "container">
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>
  <form class = "card-form"  [formGroup]="motorForm" (ngSubmit)="submitForm()" autocomplete="off" novalidate>
      <div class="blue-top"></div>
      <div class="card-section top-section ">   <!-- only renders if claim isn't theft -->
          <h1><b>{{pageHeading}}</b></h1>
          <h2>{{pageSubheading}}</h2>

          <mat-form-field appearance="outline" class="form-select">
            <mat-hint *ngIf="!motorForm.controls['vehicleReg'].value" >
                {{regHint}}
            </mat-hint>
            <mat-label class="form-select-placeholder-unselected" >{{vehicleRegLabel}}</mat-label>
            <input matInput formControlName="vehicleReg" (blur)="logErrors()" />
            <mat-error *ngIf="formErrors['vehicleReg']">
              {{ formErrors["vehicleReg"] }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-select">
            <mat-label class="form-select-placeholder-unselected">
                {{vehicleMakeLabel}}
            </mat-label>
            <mat-select formControlName="vehicleMake" (blur)="logErrors()" panelClass="form-select-popup" (selectionChange)="populateCarModelList()" [disabled]="carMakeIsEmpty">
                <mat-option class="form-option" [value]="vehicleMakePlaceHolder" *ngFor="let vehicleMakePlaceHolder of VehicleMakePlaceHolders">
                    {{vehicleMakePlaceHolder}}
                </mat-option>
            </mat-select>
            <span matPrefix *ngIf="loadingMake">
                <mat-progress-spinner mode="indeterminate" diameter="15" strokeWidth="1"></mat-progress-spinner>
            </span>
            <mat-error *ngIf="formErrors['vehicleMake']">
                {{formErrors['vehicleMake']}}
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-select">
            <mat-label class="form-select-placeholder-unselected">
                {{vehicleModelLabel}}
            </mat-label>
            <mat-select formControlName="vehicleModel"  panelClass="form-select-popup" (blur)="logErrors()" [disabled]="carModelsEmpty">
                <mat-progress-bar *ngIf="loadingModel" mode="indeterminate"></mat-progress-bar>
                <mat-option class="form-option" [value]="vehicleModelPlaceHolder" *ngFor="let vehicleModelPlaceHolder of VehicleModelPlaceHolders">
                    {{vehicleModelPlaceHolder}}
                </mat-option>
            </mat-select>
            <span matPrefix *ngIf="loadingModel">
                <mat-progress-spinner mode="indeterminate" diameter="15" strokeWidth="1"></mat-progress-spinner>
            </span>
            <mat-error *ngIf="formErrors['vehicleModel']">
                {{formErrors['vehicleModel']}}
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-select" appYearDateFormat>
            <mat-label class="form-select-placeholder-unselected">{{yearManufacturedLabel}}</mat-label>
            <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="dp" placeholder="" readonly="true" (click)="dp.open()" formControlName="yearManufactured">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp
                            startView="multi-year"
                            (yearSelected)="selectedYearHandler($event, dp)"
                            
                            panelClass="year-picker"
                            dateFormat>
            </mat-datepicker>
        </mat-form-field>
  
          <mat-form-field appearance="outline" class="form-select">
              <mat-label class="form-select-placeholder-unselected" >{{chassisNoLabel}}</mat-label>
              <input matInput formControlName="chassisNo" (blur)="logErrors()" />
              <mat-error *ngIf="formErrors['chassisNo']">
                {{ formErrors["chassisNo"] }}
              </mat-error>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="form-select">
              <mat-label class="form-select-placeholder-unselected" >{{engineNoLabel}}</mat-label>
              <input matInput formControlName="engineNo" (blur)="logErrors()" />
              <mat-error *ngIf="formErrors['engineNo']">
                {{ formErrors["engineNo"] }}
              </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-select">
            <mat-hint *ngIf="!motorForm.controls['colour'].value" >
              {{colourHint}}
            </mat-hint>
            <mat-label class="form-select-placeholder-unselected">
                {{colourLabel}}
            </mat-label>
            <input matInput formControlName="colour" [matAutocomplete]="auto" (blur)="logErrors()">
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option class="form-option" *ngFor="let color of filteredColors | async" [value]="color">
                {{color}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
  
          <mat-form-field appearance="outline" class="form-select">
              <mat-label class="form-select-placeholder-unselected" >{{seatingCapacityLabel}}</mat-label>
              <input matInput maxlength="2" formControlName="seatingCapacity" (blur)="logErrors()" />
              <mat-error *ngIf="formErrors['seatingCapacity']">
                {{ formErrors["seatingCapacity"] }}
              </mat-error>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="form-select">
              <mat-label class="form-select-placeholder-unselected" >{{ratingCCLabel}}</mat-label>
              <input matInput maxlength="4" formControlName="ratingCC" (blur)="logErrors()" />
              <mat-error *ngIf="formErrors['ratingCC']">
                {{ formErrors["ratingCC"] }}
              </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-select">
            <mat-label class="form-select-placeholder-unselected">
                {{bodyTypeLabel}}
            </mat-label>
            <mat-select formControlName="bodyType"  panelClass="form-select-popup" (blur)="logErrors()" [disabled]="bodyDisabled">
                <mat-option class="form-option" [value]="vehicleBodyTypePlaceHolders" *ngFor="let vehicleBodyTypePlaceHolders of VehicleBodyTypePlaceHolders">
                    {{vehicleBodyTypePlaceHolders}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="formErrors['bodyType']">{{formErrors['bodyType']}}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-select last-item" appFullYearDateFormat>
            <mat-label class="form-select-placeholder-unselected">{{coverStartDateLabel}}</mat-label>
            <mat-hint *ngIf="!motorForm.controls['coverStartDate'].value" >{{coveStartDateDesc}}</mat-hint>
            <input matInput  [min]="minCoverDate" [max]="maxCoverDate" (blur)="logErrors()" [matDatepicker]="picker" readonly="true" (click)="picker.open()" formControlName="coverStartDate">
            <mat-error *ngIf="formErrors['coverStartDate']">{{formErrors['coverStartDate']}}</mat-error>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker >
            </mat-datepicker>
          </mat-form-field>
  
          <div class="row-div margin-top-50">
              <button mat-stroked-button type="button" (click)="confirmCancel()">
                  <span class="button-text">{{cancel}}</span>
              </button>
              <button mat-button type="submit" [disabled]="!motorForm.valid">
                  <span class="button-text">{{saveContinue}}</span>
              </button>
          </div>
      </div>
  </form>
</div>
